export default __webpack_public_path__ + "static/media/roadworkIconEmpty.29cc066a.svg";